import { useEffect, useState } from 'react';

import { Announcement } from 'ui';

import { PendoAnnouncement, PendoAnnouncementApi } from './pendo';
import { Guide } from './pendoAnnouncments.types';
import { useGetPendoAnnouncementDomJson } from './utils/fetchDomJson';

interface PendoAnnnouncementProps {
  guide: Guide;
}

const Announcement_ = ({ guide }: PendoAnnnouncementProps) => {
  const [content, setContent] = useState<PendoAnnouncement['content'] | undefined>();
  const [announcement] = useState<PendoAnnouncement>(() => new PendoAnnouncement(guide));

  const { data, isLoading, isError } = useGetPendoAnnouncementDomJson(announcement.domJsonUrl);

  useEffect(() => {
    if (import.meta.env.DEV == false) {
      announcement?.seen();
    }
    return () => {
      if (import.meta.env.DEV == false) {
        announcement?.dismount();
      }
    };
  }, [announcement]);

  useEffect(() => {
    if (data && data !== announcement.domJson) {
      announcement.domJson = data;
      setContent(announcement.content);
    }
  }, [announcement, data]);

  if (isError) return null;

  return (
    <Announcement
      key={guide.id}
      title={content?.title}
      buttons={content?.buttons ?? undefined}
      image={content?.image}
      onClose={() => announcement?.close()}
      isLoading={isLoading}
    >
      {content?.children}
    </Announcement>
  );
};

const PendoAnnouncements = ({
  setAnnouncementCount,
}: {
  setAnnouncementCount: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const [unreadAnnouncements, setAnnouncementsContent] = useState<Guide[] | undefined>();

  const [_pendo] = useState(
    () =>
      new PendoAnnouncementApi({
        onGuidesLoaded: (pendo) => {
          setAnnouncementsContent(pendo.unseenAnnouncementGuides);
        },
        productLocation: 'ac',
      })
  );

  useEffect(() => {
    setAnnouncementCount((prev) => prev + (unreadAnnouncements?.length ?? 0));
    return () => {
      setAnnouncementCount((prev) => prev - (unreadAnnouncements?.length ?? 0));
    };
  }, [setAnnouncementCount, unreadAnnouncements?.length]);

  if (!unreadAnnouncements) return null;

  return unreadAnnouncements.map((guide, index) => {
    if (!guide) return null;
    return <Announcement_ guide={guide} key={guide.id ?? guide.name ?? index} />;
  });
};

export { PendoAnnouncements };
